import React, { Component, Fragment } from 'react';
import ContactForm from "../components/components/contactForm";
import ResponsiveAppBar from '../components/components/appbar';
import ResponsiveFooter from '../components/components/footer';
class Contact extends Component {
    render() {

        return (
            <Fragment>
                <ResponsiveAppBar />
                <div className="pageHeight">
                    <ContactForm />
                </div>
                <ResponsiveFooter />
            </Fragment>
        );
    };
};

export default Contact;